import { createContext, useContext, useState, useEffect } from 'react'
import { fetchBranding } from '../lib/api'

const BrandingContext = createContext(null)

const defaults = {
  brand_name: 'Systeza',
  brand_tagline: 'Unified Infrastructure, Automation & Growth Platform',
  logo_url: null,
  favicon_url: null,
  primary_color: '#1A6AF5',
  accent_color: '#00C8E8',
  hide_systeza_branding: false,
  is_white_labeled: false,
}

function applyVars(b) {
  const root = document.documentElement
  root.style.setProperty('--color-primary', b.primary_color)
  root.style.setProperty('--color-accent',  b.accent_color)
  if (b.favicon_url) {
    let link = document.querySelector("link[rel~='icon']") || document.createElement('link')
    link.rel  = 'icon'
    link.href = b.favicon_url
    document.head.appendChild(link)
  }
  document.title = b.brand_name
}

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(defaults)

  useEffect(() => {
    fetchBranding()
      .then((d) => { setBranding(d); applyVars(d) })
      .catch(() => applyVars(defaults))
  }, [])

  return <BrandingContext.Provider value={branding}>{children}</BrandingContext.Provider>
}

export function useBranding() {
  const ctx = useContext(BrandingContext)
  if (!ctx) throw new Error('useBranding must be within BrandingProvider')
  return ctx
}
